// extracted by mini-css-extract-plugin
module.exports = {"inputItem":"customerDetailsForm_inputItem__lTEDZ"};